import { useLocation, useSearchParams } from 'react-router-dom';
import { routes } from '../routes/router';

export const useAppRouter = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const currentRoute = routes.find(route => 
    location.pathname.startsWith(route.path.replace('/*', ''))
  );

  const updateSearchParams = (params: Record<string, string>) => {
    setSearchParams(prev => {
      const newParams = new URLSearchParams(prev);
      Object.entries(params).forEach(([key, value]) => {
        newParams.set(key, value);
      });
      return newParams;
    });
  };

  return {
    location,
    currentRoute,
    updateSearchParams,
    searchParams,
    setSearchParams
  };
}; 